var map = {
	"./1.svg": 81157,
	"./2.svg": 61286,
	"./3.svg": 7735,
	"./4.svg": 12664,
	"./5.svg": 88169,
	"./6.svg": 62586,
	"./7.svg": 67851,
	"./8.svg": 36524,
	"./9.svg": 88333
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30556;